import { render, staticRenderFns } from "./AdminInfoCard.vue?vue&type=template&id=bcbbf968&scoped=true"
import script from "./AdminInfoCard.vue?vue&type=script&lang=js"
export * from "./AdminInfoCard.vue?vue&type=script&lang=js"
import style0 from "./AdminInfoCard.vue?vue&type=style&index=0&id=bcbbf968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbbf968",
  null
  
)

export default component.exports